"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BDSA_STRATEGIST_TEMPLATES = exports.BDSA_STRATEGIST_TEMPLATES_MD = void 0;
exports.BDSA_STRATEGIST_TEMPLATES_MD = {
    'Initial Strategy Meeting (ISM)': `* Introductions - Strategist, Student, & BDSA Team\n
* Introductory School Research\n
* School Fit and Motivators\n
* Core Skills: Math & Writing\n
* Assessing Academics\n
* Assessing Extracurriculars\n
* Summer Plans (if applicable)\n
* Recap and Questions\n
* Scheduling`,
    'Parent Alignment Meeting (PAM)': `* Goal Alignment\n
* Elements of an Application\n
* Attributes of Top Candidates\n
* Student Assessment & Current Targets\n
* Timeline\n
* Sample School List`,
    'Roadmap Meeting': `* Activities List Review\n
* School Research Review\n
* Roadmap Introduction\n
* Application Overview\n
* Current Focal Points`,
    'NAY: Meeting': '* N/A',
    'AY: Tour & Event Planning': '* N/A',
    'AY: Interview Preparation': '* N/A',
    'AY: Timeline Alignment': '* N/A',
    'AY: Application Portals': '* N/A',
    'AY: Writing Alignment': '* N/A',
    'AY: Submission Meeting': '* N/A',
    'AY: Offers Review & Waitlist': '* N/A',
    'AY: Other Meeting': '* N/A',
    Other: '* N/A',
};
exports.BDSA_STRATEGIST_TEMPLATES = {
    'Initial Strategy Meeting (ISM)': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Introductions - Strategist, Student, & BDSA Team',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Introductory School Research',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'School Fit and Motivators',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Core Skills: Math & Writing',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Assessing Academics',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 6,
            type: 'p',
            children: [
                {
                    text: 'Assessing Extracurriculars',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 7,
            type: 'p',
            children: [
                {
                    text: 'Summer Plans (if applicable)',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 8,
            type: 'p',
            children: [
                {
                    text: 'Recap and Questions',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 9,
            type: 'p',
            children: [
                {
                    text: 'Scheduling',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Parent Alignment Meeting (PAM)': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Goal Alignment',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'Elements of an Application',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Attributes of Top Candidates',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Student Assessment & Current Targets',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Timeline',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 6,
            type: 'p',
            children: [
                {
                    text: 'Sample School List',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Roadmap Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'Activities List Review',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 2,
            type: 'p',
            children: [
                {
                    text: 'School Research Review',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 3,
            type: 'p',
            children: [
                {
                    text: 'Roadmap Introduction',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 4,
            type: 'p',
            children: [
                {
                    text: 'Application Overview',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
        {
            listStart: 5,
            type: 'p',
            children: [
                {
                    text: 'Current Focal Points',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'NAY: Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Tour & Event Planning': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Interview Preparation': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Timeline Alignment': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'Application Portals': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Writing Alignment': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Submission Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    'AY: Other Meeting': [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
    Other: [
        {
            listStart: 1,
            type: 'p',
            children: [
                {
                    text: 'N/A',
                },
            ],
            listStyleType: 'disc',
            indent: 1,
        },
    ],
};
//# sourceMappingURL=bdsa-strategist.js.map